import LearnerAcrossFacetsChart from '@/components/charts/learner-across-facets-chart/learner-across-facets-chart';
import TaxonomyFilter from '@/components/selector/taxonomy-filter/taxonomy-filter';
import { LearnerVector } from '@/models/proficiency/learner-vector';
import { SubjectModel } from '@/models/taxonomy/subject';
import { learnerAPI } from '@/providers/apis/learner/learner';
import { Vue, Component, Prop } from 'vue-property-decorator';
import LearnerFacts from './learner-facts/learner-facts';
import axios from 'axios';
import { profileAPI } from '@/providers/apis/profile/profile';
import moment from 'moment';
import { LEARNER_MINDSETS_VECTORS, TEMP_CONST_LEARNER, VECTOR_VALUES } from '@/utils/constants';
import StudentTreeChartComponent from '@/components/showcase/student-tree-chart/student-tree-chart';
import LearningIdentityChartLine from '@/components/charts/learner-identity-chart-line/learner-identity-chart-line';

@Component({
    name: 'learner-identity',
    components: {
       'learner-facets': LearnerFacts,
       'vector-chart': () => import('./vector-chart/vector-chart'),
       'behavior': () => import('./behavior/behavior'),
       'learner-across-facets-chart': LearnerAcrossFacetsChart,
       'student-tree-view': StudentTreeChartComponent,
       'learner-identity-line': LearningIdentityChartLine,
    },
})

export default class LearnerIdentity extends Vue {

    // ------------------------------------------------------------------------
    // Properties


    private taxonomyFiler: TaxonomyFilter = new TaxonomyFilter();

    private selectedSubjects: SubjectModel[] = [];

    private mindSetData: any = [];

    private citizenData: any = [];

    private userInfo: any = null;

    private month: any = '02';

    private year: any = '2020';

    private isShowProficiencyChart: boolean = false;

    private isLoading: boolean = false;


    private chartData: any = [
        {
            label: 'Social interaction ',
            value: 0.30,
        },
        {
            label: 'Emotion',
            value: 0.50,
        },
        {
            label: 'Stress',
            value: 0.20,
        },
        {
            label: 'Interest',
            value: 0.80,
        },
    ];

    @Prop({})
    private learnerId!: string;

    private mounted() {
        if (this.learnerId) {
            this.$route.params.id = this.learnerId;
        }
        this.taxonomyFiler.loadFilterOutside(this.$route.params.id);
        this.taxonomyFiler.$on('listActiveFacets', (activeFacts: SubjectModel[]) => {
            this.selectedSubjects = [...new Map(activeFacts.map((item) => [item.id, item])).values()];
          });

        this.loadMindsets();
    }

    // -----------------------------------------------------------------------------------
    // Actions

    private onSelectFacets() {
        this.$router.push({path: `/learners/${this.$route.params.id}`, query: {filter: 'true'}});
    }

    private onGoBack() {
        this.$router.push('/learners');
    }

    private zoomEvent(refString: any = null, isRemove = false) {
            (this.$refs[refString] as HTMLElement).classList[ isRemove ? 'remove' : 'add']('show-big-screen');
    }
    // ---------------------------------------------------------------------------------
    // Methods


    private loadMindsets() {
        this.isLoading = true;
        const requestParams: any = {
            user: this.$route.params.id,
        };
        axios.all([
            profileAPI.fetchUserProfiles(requestParams.user),
            learnerAPI.fetchLearnerVectors(requestParams) as any,
        ]).then(axios.spread((userDetails, learnerVectorPoints: LearnerVector[]) => {
            this.userInfo = userDetails[0];
            if (TEMP_CONST_LEARNER.indexOf(requestParams.user) !== -1) {
                learnerVectorPoints = VECTOR_VALUES;
            }
            const activeList = LEARNER_MINDSETS_VECTORS;
            this.mindSetData = learnerVectorPoints.filter((item) => activeList.indexOf(item.label) !== -1);
            this.citizenData = learnerVectorPoints.filter((item) => activeList.indexOf(item.label) === -1);
            this.isLoading = false;
        }));
    }





}
